<template>
    <div class="container body-content formdemande">
        <cogi-loading-spinner />

        <div>
            <cogi-tabs ref="tabs" @tab-clicked="tabClicked" valider-sur-onglet>
                <cogi-tab ref="tab1" title="Etape1" subtitle="ProfilDuDemandeur" :selected="true">
                    <cogi-titresection
                        v-model="vm.culture"
                        :utilise-multilangue="vm.utiliseMultilangue!"
                        :langues="vm.langues!"
                        :imageIcone="vm.imageIcone"
                        titre="IdentificationDuDemandeur"
                        tooltip="ToolTipSection1" />
                    <cogi-etape1
                        v-if="ready"
                        ref="content1"
                        v-model="vm"
                        :sourceItemsSexe="vm.sexes as del.ListItem[]"
                        :sourceItemsTypeLogement="vm.listeTypeDeLogement as del.ListItem[]"
                        :sourceItemsSoldeHypotheque="vm.listeSoldeHypotheque as del.ListItem[]"
                        :sourceItemsStatutResidence="vm.statutsResidence as del.ListItem[]"
                        :sourceItemsLangueParlee="vm.listeLangueParlee as del.ListItem[]"
                        :sourceItemsPaysNaissance="vm.paysNaissance as del.ListItem[]"
                        @avancerUnEtape="avancerUnEtape" />
                </cogi-tab>
                <cogi-tab ref="tab2" title="Etape2" subtitle="ProfilDuMenage">
                    <cogi-titresection
                        v-model="vm.culture"
                        :utilise-multilangue="vm.utiliseMultilangue!"
                        :langues="vm.langues!"
                        :imageIcone="vm.imageIcone"
                        titre="ProfileDuMenageCaps"
                        tooltip="ToolTipSection2" />
                    <cogi-etape2
                        v-if="ready"
                        ref="content2"
                        v-model="vm"
                        :sourceItemsSexe="vm.sexes!"
                        :sourceItemsPaysNaissance="vm.paysNaissance!"
                        :sourceItemsLienParente="vm.lienParentes!"
                        :sourceItemsLienParentesEstSansSousTutelleChefOuConjointPossible="vm.lienParentesEstSansSousTutelleChefOuConjointPossible!"
                        :sourceItemsStatutResidence="vm.statutsResidence!"
                        :sourceItemsSituation="vm.listeSituation!"
                        @avancerUnEtape="avancerUnEtape"
                        @reculerUnEtape="reculerUnEtape" />
                </cogi-tab>
                <cogi-tab ref="tab3" title="Etape3" subtitle="AutonomieEtAutres">
                    <cogi-titresection
                        v-model="vm.culture"
                        :utilise-multilangue="vm.utiliseMultilangue!"
                        :langues="vm.langues!"
                        :imageIcone="vm.imageIcone"
                        titre="QuestionComplementaireEtAutonomieCaps"
                        tooltip="ToolTipSection3" />
                    <cogi-etape3
                        v-if="ready"
                        ref="content3"
                        v-model="vm"
                        :sourceItemsMarquesVehicule="vm.marquesVehicule!"
                        @avancerUnEtape="avancerUnEtape"
                        @reculerUnEtape="reculerUnEtape" />
                </cogi-tab>
                <cogi-tab ref="tab4" title="Etape4" subtitle="TerritoireEtModeles">
                    <cogi-titresection
                        v-model="vm.culture"
                        :utilise-multilangue="vm.utiliseMultilangue!"
                        :langues="vm.langues!"
                        :imageIcone="vm.imageIcone"
                        titre="VosPreferenceDeTerritoiresCaps"
                        tooltip="ToolTipSection4" />
                    <cogi-etape4
                        v-if="ready"
                        ref="content4"
                        v-model="vm"
                        :sourceItemsTerritoire="vm.territoires as del.ListItem[]"
                        :sourceItemsImplicationOrganisme="vm.implicationOrganisme as del.ListItem[]"
                        :sourceItemsServiceDesires="vm.serviceDesires as del.ListItem[]"
                        :sourceItemsResponsabiliteCoop="vm.responsabiliteCoop as del.ListItem[]"
                        @avancerUnEtape="avancerUnEtape"
                        @reculerUnEtape="reculerUnEtape" />
                </cogi-tab>
                <cogi-tab ref="tab5" title="Etape5" subtitle="FinaliserLaDemande">
                    <cogi-titresection
                        v-model="vm.culture"
                        :utilise-multilangue="vm.utiliseMultilangue!"
                        :langues="vm.langues!"
                        :imageIcone="vm.imageIcone"
                        titre="AttestationEtPiecesJustificativesCaps"
                        tooltip="ToolTipSection5" />
                    <cogi-etape5
                        v-if="ready"
                        ref="content5"
                        v-model="vm"
                        v-model:files="files"
                        :sourceItemPointServices="vm.listePointServices!"
                        :sourceItemLienDemandeur="vm.lienParentesDemandeur!"
                        @reculerUnEtape="reculerUnEtape"
                        @soumettre="soumettre" />
                </cogi-tab>
            </cogi-tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type Ref, ref, reactive } from 'vue'
    import { del } from '../../clients/delclient'
    import CogiTitresection from './shared/CogiTitresection.vue'
    import CogiEtape1 from './shared/CogiEtape1.vue'
    import CogiEtape2 from './shared/CogiEtape2.vue'
    import CogiEtape3 from './shared/CogiEtape3.vue'
    import CogiEtape4 from './shared/CogiEtape4.vue'
    import CogiEtape5 from './shared/CogiEtape5.vue'
    import CogiTab from './shared/CogiTab.vue'
    import CogiTabs from './shared/CogiTabs.vue'
    import CogiLoadingSpinner from './shared/CogiLoadingSpinner.vue'
    import DemandeEnLigneVM from './DemandeEnLigneVM'

    /*
    const tabs = useTemplateRef<InstanceType<typeof CogiTabs>>('tabs')
    const tab1 = useTemplateRef<InstanceType<typeof CogiTab>>('tab1')
    const tab2 = useTemplateRef<InstanceType<typeof CogiTab>>('tab2')
    const tab3 = useTemplateRef<InstanceType<typeof CogiTab>>('tab3')
    const tab4 = useTemplateRef<InstanceType<typeof CogiTab>>('tab4')
    const tab5 = useTemplateRef<InstanceType<typeof CogiTab>>('tab5')

    const content1 = useTemplateRef<InstanceType<typeof CogiEtape1>>('content1')
    const content2 = useTemplateRef<InstanceType<typeof CogiEtape2>>('content2')
    const content3 = useTemplateRef<InstanceType<typeof CogiEtape3>>('content3')
    const content4 = useTemplateRef<InstanceType<typeof CogiEtape4>>('content4')
    const content5 = useTemplateRef<InstanceType<typeof CogiEtape5>>('content5')
    */
    const tabs: Ref<typeof CogiTabs | null> = ref(null)
    const tab1 = ref(null)
    const tab2 = ref(null)
    const tab3 = ref(null)
    const tab4 = ref(null)
    const tab5 = ref(null)

    const content1: Ref<typeof CogiEtape1 | null> = ref(null)
    const content2: Ref<typeof CogiEtape2 | null> = ref(null)
    const content3: Ref<typeof CogiEtape3 | null> = ref(null)
    const content4: Ref<typeof CogiEtape4 | null> = ref(null)
    const content5: Ref<typeof CogiEtape5 | null> = ref(null)

    const ready = ref<boolean>(false)
    const files = ref(new Array<File>())

    interface IPropsForm {
        c?: string
        noSuccursale?: string
        langue: 'fr' | 'en'
    }

    const props = withDefaults(defineProps<IPropsForm>(), {
        langue: 'fr',
    })

    const emit = defineEmits<{
        complete: [
            {
                codeDemande: string
                adresseOrganisme?: string
                telephoneOrganisme?: string
                courrielOrganisme?: string
                siteOrganisme?: string
                imageLogo?: { extension: string; contenuBase64: string }
            },
        ]
    }>()

    let vm = reactive(new DemandeEnLigneVM(props.langue))

    vm.initialiserVM(props.c!, props.noSuccursale ? parseInt(props.noSuccursale!) : undefined).then(() => (ready.value = true))

    async function tabClicked(currentTabIndex: number, futureTabIndex: number) {
        if (futureTabIndex > currentTabIndex) {
            let i = currentTabIndex
            let isValid = false
            do {
                isValid = await isTabValid(i)

                if (isValid) i++
            } while (isValid && i < futureTabIndex)

            if (i != currentTabIndex) selectionnerTab(i)
        } else {
            selectionnerTab(futureTabIndex)
        }
    }

    function getContent(tabIndex: number): typeof CogiEtape1 | typeof CogiEtape2 | typeof CogiEtape3 | typeof CogiEtape4 | typeof CogiEtape5 {
        switch (tabIndex) {
            case 0:
                return content1.value as typeof CogiEtape1
            case 1:
                return content2.value as typeof CogiEtape2
            case 2:
                return content3.value as typeof CogiEtape3
            case 3:
                return content4.value as typeof CogiEtape4
            case 4:
                return content5.value as typeof CogiEtape5
            default:
                throw 'tab invalide!'
        }
    }

    async function isTabValid(tabIndex: number): Promise<boolean> {
        return new Promise(resolve => {
            const content = getContent(tabIndex)
            content.validateCallback = (hasError: boolean) => resolve(!hasError)
            content.validate()
        })
    }

    function avancerUnEtape(indexTab: number) {
        selectionnerTab(indexTab + 1)
        window.scrollTo(0, 0)
    }

    function reculerUnEtape(indexTab: number) {
        selectionnerTab(indexTab - 1)
        window.scrollTo(0, 0)
    }

    function selectionnerTab(indexTab: number) {
        const cogiTabs = tabs.value as typeof CogiTabs
        switch (indexTab) {
            case 0:
                cogiTabs.selectTab(tab1.value)
                break
            case 1:
                cogiTabs.selectTab(tab2.value)
                break
            case 2:
                cogiTabs.selectTab(tab3.value)
                break
            case 3:
                cogiTabs.selectTab(tab4.value)
                break
            case 4:
                cogiTabs.selectTab(tab5.value)
                break
        }
    }

    function soumettre() {
        vm.soumettre(files.value, (value: string) =>
            emit('complete', {
                codeDemande: value,
                adresseOrganisme: vm.adresseOrganisme,
                telephoneOrganisme: vm.telephoneOrganisme,
                courrielOrganisme: vm.courrielOrganisme,
                siteOrganisme: vm.dicUrlSiteAccueil?.[vm.culture!],
                imageLogo: vm.imageLogo != undefined ? { extension: vm.imageLogo.extension!, contenuBase64: vm.imageLogo.contenuBase64! } : undefined,
            }),
        )
    }
</script>
